import * as React from "react";
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={54}
      height={55}
      viewBox="0 0 54 55"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <G clipPath="url(#clip0_1_1742)">
        <Path
          d="M44.55 17.875c0 4.383-1.603 8.422-4.134 11.515-2.025 2.407-3.375 5.243-3.881 8.336h-7.847v-5.5l3.628-3.695c.675-.688.675-1.719 0-2.32a1.516 1.516 0 00-2.278 0L27 29.305l-2.953-3.008c-.675-.688-1.687-.688-2.278 0-.675.601-.675 1.718 0 2.32l3.628 3.695v5.5h-7.931a19.187 19.187 0 00-3.966-8.507c-2.784-3.352-4.303-7.82-3.965-12.633.59-8.508 7.172-15.555 15.525-16.5 10.547-1.29 19.49 7.132 19.49 17.703zM24.216 55h5.569c3.29 0 6.075-2.578 6.412-5.844H17.803C18.142 52.422 20.841 55 24.216 55zm-6.497-13.922v4.812h18.563v-4.812H17.719z"
          fill="#F6F7F9"
        />
      </G>
      <Defs>
        <ClipPath id="clip0_1_1742">
          <Path fill="#fff" d="M0 0H54V55H0z" />
        </ClipPath>
      </Defs>
    </Svg>
  );
}

export default SvgComponent;
